import { RootState } from '..'

const uploadingType = (state: RootState) => state.materials.uploadingType
const getAdditionalMaterials = (state: RootState) => state.materials?.additionalFiles

export default {
  uploadingType,
  getAdditionalMaterials,
}
